module.exports = __webpack_public_path__ + "img/PTakabara64_ua.6d5ec990.webp";